<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>{{id ? 'Update' : 'Add New'}} Role</h2>
  <!-- <button nz-button nzType="primary">Add User</button> -->
</div>

<!--form section-->
<section [ngClass]="!loading ? 'block' : 'hidden'">
  <nz-card>
    <div class="grid sm:grid-cols-2 lg:grid-cols-4">
      <div class="mb-14">
        <p class="text-primary text-md mb-2">Role Name</p>
        <input class="" nz-input placeholder="Enter Role Name" [(ngModel)]="name" (ngModelChange)="checkRoleNameValid()"
               [nzStatus]="nameInvalid ? 'error' : ''"/>
        <span *ngIf="nameInvalid" class="text-red-500 text-xs">Name is required</span>
      </div>
    </div>
    <div class="flex flex-row items-center mb-2 mt-[-24px]">
      <div>
        <p class="text-primary text-md mb-5">Permissions</p>
      </div>
      <div class="px-3 w-full">
        <hr class=" h-0.5 border-t-0 bg-neutral-300 opacity-100 dark:opacity-50"/>
      </div>
    </div>
    <div class="">
      <div class="flex flex-col mb-4">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-5">
          <div class="">
            <p class="mb-2 font-bold">User Management</p>
            <p class="mb-2">User Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col" (ngModelChange)="log(userPermissions, 'user', $event)"
                               [(ngModel)]="userPermissions"></nz-checkbox-group>
            <p class="mb-2">Role Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col" (ngModelChange)="log(rolePermissions, 'role', $event)"
                               [(ngModel)]="rolePermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Driver Management</p>
            <p class="mb-2 ">Driver Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(driverPermissions, 'driver', $event)"
                               [(ngModel)]="driverPermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Supplier Management</p>
            <p class="mb-2">Supplier Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(supplierPermissions, 'supplier', $event)"
                               [(ngModel)]="supplierPermissions"></nz-checkbox-group>
            <p class="mb-2">Vehicle Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(supplierVehiclePermissions, 'supplier-vehicle', $event)"
                               [(ngModel)]="supplierVehiclePermissions"></nz-checkbox-group>
            <p class="mb-2">Driver Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(supplierDriverPermissions, 'supplier-driver', $event)"
                               [(ngModel)]="supplierDriverPermissions"></nz-checkbox-group>
            <p class="mb-2">Notes Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(supplierNotePermissions, 'supplier-note', $event)"
                               [(ngModel)]="supplierNotePermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Customer Management</p>
            <p class="mb-2 ">Customer Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(customerPermissions, 'customer', $event)"
                               [(ngModel)]="customerPermissions"></nz-checkbox-group>
            <p class="mb-2 ">Notes and Attachments Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(customerNotesAttachmentsPermissions, 'customer-note-attachment', $event)"
                               [(ngModel)]="customerNotesAttachmentsPermissions"></nz-checkbox-group>

            <!--            <p class="mb-2 ">Notes Permissions</p>-->
            <!--            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"-->
            <!--                               (ngModelChange)="log(customerNotesPermissions, 'customer-notes')"-->
            <!--                               [(ngModel)]="customerNotesPermissions"></nz-checkbox-group>-->
            <!--            <p class="mb-2 ">Attachments Permissions</p>-->
            <!--            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"-->
            <!--                               (ngModelChange)="log(customerAttachmentsPermissions, 'customer-attachments')"-->
            <!--                               [(ngModel)]="customerAttachmentsPermissions"></nz-checkbox-group>-->
            <p class="mb-2 ">Booking Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(customerBookingPermissions, 'customer-booking', $event)"
                               [(ngModel)]="customerBookingPermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Fleet Management</p>
            <p class="mb-2">Fleet Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col" (ngModelChange)="log(fleetPermissions, 'fleet', $event)"
                               [(ngModel)]="fleetPermissions"></nz-checkbox-group>
            <p class="mb-2">Inventory Records Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(inventoryRecordsPermissions, 'inventory', $event)"
                               [(ngModel)]="inventoryRecordsPermissions"></nz-checkbox-group>
            <p class="mb-2">Service Records Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(serviceRecordsPermissions, 'service', $event)"
                               [(ngModel)]="serviceRecordsPermissions"></nz-checkbox-group>
            <p class="mb-2">Repair Records Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(repairRecordsPermissions, 'repair', $event)"
                               [(ngModel)]="repairRecordsPermissions"></nz-checkbox-group>
            <p class="mb-2">Accident Records Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(accidentRecordsPermissions, 'accident', $event)"
                               [(ngModel)]="accidentRecordsPermissions"></nz-checkbox-group>
            <p class="mb-2">Notes and Attachments Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(notesAndAttachmentsPermissions, 'notes', $event)"
                               [(ngModel)]="notesAndAttachmentsPermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Rent Booking Management</p>
            <p class="mb-2">Rent Booking Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(rentBookingPermissions, 'rent_booking', $event)"
                               [(ngModel)]="rentBookingPermissions"></nz-checkbox-group>

          </div>

          <div>
            <p class="mb-2 font-bold">Transfer Booking Management</p>
            <p class="mb-2">Transfer Booking Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(transferBookingPermissions, 'transfer_booking', $event)"
                               [(ngModel)]="transferBookingPermissions"></nz-checkbox-group>
          </div>
          <div>
            <p class="mb-2 font-bold">Other Booking Management</p>
            <p class="mb-2">Other Booking Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(otherBookingPermissions, 'other_booking', $event)"
                               [(ngModel)]="otherBookingPermissions"></nz-checkbox-group>
          </div>
          <div class="">
            <p class="mb-2 font-bold">Agent Management</p>
            <p class="mb-2 ">Agent Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col" (ngModelChange)="log(agentPermissions, 'agent', $event)"
                               [(ngModel)]="agentPermissions"></nz-checkbox-group>
            <p class="mb-2 ">Booking Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(agentBookingPermissions, 'agent_bookings', $event)"
                               [(ngModel)]="agentBookingPermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Currency Management</p>
            <p class="mb-2 ">Currency Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(currencyPermissions, 'currency', $event)"
                               [(ngModel)]="currencyPermissions"></nz-checkbox-group>
          </div>

          <div class="">
            <p class="mb-2 font-bold">Report Management</p>
            <p class="mb-2 ">Report Permissions</p>
            <nz-checkbox-group class="mb-4 ml-5 flex flex-col"
                               (ngModelChange)="log(reportPermissions, 'report', $event)"
                               [(ngModel)]="reportPermissions"></nz-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="pr-3 w-full mb-4">
        <hr class="h-0.5 border-t-0 bg-neutral-300 opacity-100 dark:opacity-50"/>
      </div>
      <div class="flex justify-end">
        <button nz-button nzType="primary" [disabled]="checkValid()" (click)="addEditRole()">Update Role
        </button>
      </div>
      <nz-alert *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type"
                [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>
    </div>
  </nz-card>
</section>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

